import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';

const DeleteDialog = ({deleteDialog, setDeleteDialog}) => {
    const closeHandler = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
            setDeleteDialog(false)
    };
    return (
        <>
            <Dialog
                open={deleteDialog}
                onClose={closeHandler}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CloseIcon sx={{ float: 'right', cursor: 'pointer', marginLeft: 'auto' }} onClick={closeHandler} />
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center' }}>
                    <Typography className="text1Bold">
                        Your service has been deleted.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', backgroundColor: '#2544EE' }}>
                    <Button className="text1Mid" sx={{ color: '#000', background: '#FFF', px: 5 }} onClick={closeHandler}>Ok</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DeleteDialog;